const URL = {
  WORKSPACE_MEMBERS: 'ShopMember/{shopId}/members',
  WORKSPACE_MEMBER_INVITE: 'ShopMember/{shopId}/members/invite',
  WORKSPACE_MEMBER_PERMISSIONS: 'ShopMember/{shopId}/members/{userId}/permissions',
  WORKSPACE_MEMBER_DELETE: 'ShopMember/{shopId}/members/{userId}',
  WORKSPACE_MEMBER_REVOKE_INVITE: 'ShopMember/{shopId}/members/invite',
  WORKSPACE_PERMISSION_PRESETS: 'ShopMember/{shopId}/permissions/presets',
  WORKSPACE_INVITE_ACCEPT: 'ShopMember/invite/accept',
}

export default URL
